/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Components */
import SwimlaneSkeleton from '../SwimlaneSkeleton';

/* Styles */
import './SwimlaneVodSkeleton.scss';

const NUMBER_OF_CARDS = 8;

function SwimlaneVodSkeleton({
  withTitle,
}) {
  return (
    <SwimlaneSkeleton withTitle={withTitle}>
      {Array.from({ length: NUMBER_OF_CARDS }).fill().map((value, index) => (
        // eslint-disable-next-line react/no-array-index-key -- only presentational
        <div className="dtv-html5-c-swimlane-vod-skeleton__card" key={index}>
          <Skeleton
            className="dtv-html5-c-swimlane-vod-skeleton__card-image"
          />
          <div className="dtv-html5-c-swimlane-vod-skeleton__card-info">
            <Skeleton
              className="dtv-html5-c-swimlane-vod-skeleton__card-title"
            />
            <Skeleton
              className="dtv-html5-c-swimlane-vod-skeleton__card-description"
            />
          </div>
        </div>
      ))}
    </SwimlaneSkeleton>
  );
}

SwimlaneVodSkeleton.propTypes = {
  withTitle: PropTypes.bool,
};

SwimlaneVodSkeleton.defaultProps = {
  withTitle: true,
};

export default memo(SwimlaneVodSkeleton);
